import React from 'react';
import PropTypes from 'prop-types';

import {
  Col,
  Grid,
  Card,
  CardContent,
  Button,
  LinkTo,
} from '@common/components';

import { useTranslation } from 'react-i18next';
import { dateFormat } from '@dashboard/util';

import userStyles from './UserCard.module.scss';

export default function UserCard({ user, onDelete }) {
  const { t } = useTranslation('dashboard\\UserCard');

  return (
    user && (
      <Card
        className={
          user.active === false ? userStyles.inactive : userStyles.active
        }
      >
        <CardContent>
          <Grid align="middle" justify="space-between">
            <Col xss={12} xs={12} sm={10} md={10}>
              <Grid align="middle" justify="space-between">
                <Col xss={12} xs={12} sm={6} md={6} lg={5}>
                  <Grid>
                    <Col xss={12} xs={12} sm={6} md={6}>
                      <div className={userStyles.section}>
                        <span>{t('labelProject')}</span>
                        <strong>
                          {user.projects && user.projects.length
                            ? user.projects.map((p) => p.name).join(', ')
                            : t('lblEmpty')}
                          &nbsp;
                        </strong>
                      </div>
                    </Col>
                    <Col xss={12} xs={12} sm={6} md={6}>
                      <div className={userStyles.section}>
                        <span>{t('labelName')}</span>
                        <strong>{`${user.first_name} ${user.last_name}`}</strong>
                      </div>
                    </Col>
                  </Grid>
                </Col>
                <Col xss={12} xs={12} sm={10} md={10} lg={7}>
                  <Grid align="middle" justify="space-between">
                    <Col xss={12} xs={12} sm={12} md={12}>
                      <div className={userStyles.sectionOdd}>
                        <span>{t('labelEmail')}</span>
                        <strong>{user.email}</strong>
                      </div>
                    </Col>
                    <Col xss={12} xs={12} sm={12} md={12}>
                      <div className={userStyles.sectionOdd}>
                        <span>{t('labelLastAccess')}</span>
                        <strong>
                          {user.last_access
                            ? dateFormat(user.last_access)
                            : t('lblEmpty')}
                        </strong>
                      </div>
                    </Col>
                  </Grid>
                </Col>
              </Grid>
            </Col>
            <Col
              xss={12}
              xs={12}
              sm={2}
              md={2}
              lg={2}
              className={userStyles.btnContainer}
            >
              {user.active !== false && (
                <div
                  className={`${userStyles.section} ${userStyles.row}  ${userStyles.buttons}`}
                >
                  <Button variant="raised" color="error" onClick={onDelete}>
                    {t('labelDelete')}
                  </Button>

                  <LinkTo
                    button
                    href={`/dashboard/users/${user.uuid}`}
                    variant="raised"
                    color="accent"
                  >
                    {t('labelEdit')}
                  </LinkTo>
                </div>
              )}
            </Col>
          </Grid>
        </CardContent>
      </Card>
    )
  );
}

UserCard.propTypes = {
  user: PropTypes.object,
  onDelete: PropTypes.func,
};
